import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import {UserInfoService} from '@portal-commons/providers/user-info.service';

@Injectable()
export class IsAdminGuard  {
  constructor(private userInfoService: UserInfoService) {}

  canActivateChild(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.userInfoService.isAdmin();
  }
}
